function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2.1755 6.98283C2.87326 6.98283 3.40684 6.45208 3.40684 5.75802C3.40684 5.06396 2.87326 4.5332 2.1755 4.5332C1.47774 4.5332 0.944153 5.06396 0.944153 5.75802C0.944153 6.41125 1.47774 6.98283 2.1755 6.98283Z",
  fill: "#0851DF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.22761 8.53407C3.65299 7.39091 2.25746 6.94181 1.14925 7.51339C0.697761 7.71752 0.328358 8.08497 0.123134 8.53407L0.0410448 8.65655C0 8.69738 0 8.77903 0 8.81986V9.75888C0 9.92219 0.123134 10.0855 0.328358 10.0855H4.02239C4.18657 10.0855 4.35075 9.96302 4.35075 9.75888V8.81986C4.35075 8.77903 4.35075 8.7382 4.3097 8.69738L4.22761 8.53407Z",
  fill: "#0851DF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M2.66788 2.85867H5.2537V3.67522L7.38803 2.4504L5.2537 1.22559V2.04213H2.25743C2.05221 2.04213 1.84698 2.20544 1.84698 2.4504V3.92018H2.66788V2.85867Z",
  fill: "#4992FD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.76873 0.000976562H5.25381V0.81752H9.76873C10.015 0.81752 10.1792 0.980828 10.1792 1.22579V8.77881C10.1792 9.02378 10.015 9.18709 9.76873 9.18709H6.27993C6.03366 9.18709 5.86948 9.02378 5.86948 8.77881V4.247H5.04858V8.77881C5.04858 9.47288 5.58217 10.0036 6.27993 10.0036H9.76873C10.4665 10.0036 11.0001 9.47288 11.0001 8.77881V1.22579C11.0001 0.531729 10.4254 0.000976562 9.76873 0.000976562Z",
  fill: "#38435E"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M7.01862 8.2891C7.01862 8.41158 7.10071 8.49323 7.22384 8.49323H8.98877C9.1119 8.49323 9.19399 8.41158 9.19399 8.2891C9.19399 8.16662 9.1119 8.08496 8.98877 8.08496H7.22384C7.10071 8.08496 7.01862 8.16662 7.01862 8.2891Z",
  fill: "#38435E"
});

var SvgButtonlink = function SvgButtonlink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgButtonlink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/buttonlink.96290a4a.svg";
export { ForwardRef as ReactComponent };